import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';

export default [
  <ShowocaseLayout
    key="/business/showcase/beard-dye"
    exact
    path="/business/showcase/beard-dye"
    component={AsyncPage}
  />,
];
